import jwt_decode from "jwt-decode";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ReactDrawer from "react-drawer";
import "react-drawer/lib/react-drawer.css";
//i18n
import { withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  BU_TENANT_HEADER,
  ROLE_ADMIN,
  TENANT_CODE_HEADER,
} from "store/auth/login/actionTypes";
import { GET_LIST_BU_TENANT_HEADER_SUCCESS } from "store/dashboard/actionTypes";
import {
  default as logoDark,
  default as logoLight,
} from "../../assets/images/logo1.png";
import {
  default as logo,
  default as logoLightSvg,
} from "../../assets/images/logo2.png";
// Redux Store
import {
  getListBUStoreHeader,
  getListBUTenantHeader,
  getListTenantHeader,
  setBUStoreHeader,
  setBUTenantHeader,
  setTenantCodeHeader,
  showRightSidebarAction,
  toggleLeftmenu,
} from "../../store/actions";
import RightSidebar from "../CommonForBoth/RightSidebar";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
const Header = props => {
  const [menu, setMenu] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [position, setPosition] = useState();
  const [open, setOpen] = useState(false);

  const toggleTopDrawer = () => {
    setPosition("right");
    setOpen(!open);
  };

  const onDrawerClose = () => {
    setOpen(false);
  };

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const Dashboard = useSelector(state => state.Dashboard);

  const { listTenant, tenantCodeHeader, listBuOfTenant, listBuStore, type } =
    Dashboard;
  const [isShowSelectTenant, setIsShowSelectTenant] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);

  const [selectedBU, setSelectedBU] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      // Check if User admin thì cho chọn tenant
      if (roleUser === ROLE_ADMIN) {
        setIsShowSelectTenant(true);
      } else {
        // Không phải admin thì mặc định tenant của user login
        setIsShowSelectTenant(false);
        const tenantCode = info["userInfo"]["tenantCode"];
        dispatch(setTenantCodeHeader(tenantCode));
      }
    }
  }, []);

  useEffect(() => {
    if (isShowSelectTenant) {
      dispatch(getListTenantHeader());
    }
  }, [isShowSelectTenant]);

  useEffect(() => {
    if (tenantCodeHeader) {
      dispatch(getListBUTenantHeader());
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (listTenant && listTenant.length > 0) {
      const tenantCode = localStorage.getItem(TENANT_CODE_HEADER);
      if (tenantCode) {
        const value = listTenant.find(item => item.value === tenantCode);
        setSelectedTenant(value);
      } else {
        // Set mặc định tenant
        setSelectedTenant(listTenant[0]);
      }
    }
  }, [listTenant]);

  useEffect(() => {
    if (type === GET_LIST_BU_TENANT_HEADER_SUCCESS) {
      if (listBuOfTenant.length > 0) {
        const buTenant = localStorage.getItem(BU_TENANT_HEADER);
        if (buTenant) {
          const value = listBuOfTenant.find(item => item.code === buTenant);
          if (value) {
            setSelectedBU(value);
          } else {
            setSelectedBU(listBuOfTenant[0]);
          }
        } else {
          // Set mặc định BU
          setSelectedBU(listBuOfTenant[0]);
        }
      } else {
        setSelectedBU(null);
      }
    }
  }, [type]);

  useEffect(() => {
    if (listBuStore && listBuStore.length > 0) {
      const buStore = localStorage.getItem(BU_STORE_HEADER);
      if (buStore) {
        const store = listBuStore.find(item => item.value === buStore);
        if (store) {
          setSelectedStore(store);
        } else {
          // Set mặc định store
          if (listBuStore.length > 1) {
            setSelectedStore(listBuStore[1]);
          } else {
            setSelectedStore(listBuStore[0]);
          }
        }
      } else {
        // Set mặc định store
        if (listBuStore.length > 1) {
          setSelectedStore(listBuStore[1]);
        } else {
          setSelectedStore(listBuStore[0]);
        }
      }
    } else if (listBuStore && listBuStore.length === 0) {
      if (selectedBU) {
        dispatch(setBUStoreHeader(selectedBU.code, selectedBU.code));
      }
      setSelectedStore(null);
    }
  }, [JSON.stringify(listBuStore)]);

  // Thay đổi tenant thì lưu vào local storage (x-tenant header)
  useEffect(() => {
    if (selectedTenant) {
      dispatch(setTenantCodeHeader(selectedTenant.value));
    }
  }, [selectedTenant]);

  // Thay đổi  đơn vị thì lưu vào local storage
  useEffect(() => {
    if (selectedBU) {
      dispatch(setBUTenantHeader(selectedBU.code, selectedBU));
      // gọi api get store của đơn vị
      dispatch(getListBUStoreHeader(selectedBU.value));
    }
  }, [selectedBU]);

  // Thay đổi Chi nhánh thì lưu vào local storage todo
  useEffect(() => {
    if (selectedStore) {
      if (selectedBU) {
        dispatch(setBUStoreHeader(selectedBU.code, selectedStore.value));
      }
    }
  }, [selectedStore]);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src={logoLightSvg}
                    alt=""
                    height="22"
                    style={{ marginLeft: "23px" }}
                  />
                </span>
                <span className="logo-lg">
                  <img
                    style={{
                      transform: "scale(0.5)",
                      marginLeft: "-88px",
                    }}
                    src={logoLight}
                    alt=""
                    height="90"
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            {listTenant?.length > 1 && (
              <React.Fragment>
                <div
                  className="d-flex align-items-center"
                  style={{
                    marginRight: "12px",
                    // marginLeft: "30px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Tenant:
                </div>
                {isShowSelectTenant ? (
                  <div
                    className="app-search d-lg-block"
                    style={{ minWidth: "200px", marginTop: "10px" }}
                  >
                    <Select
                      placeholder="Chọn Tenant muốn xem dữ liệu..."
                      value={selectedTenant}
                      onChange={e => {
                        setSelectedTenant(e);
                      }}
                      options={listTenant}
                      classNamePrefix="select2-selection"
                    />
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center"
                    style={{ color: "white" }}
                  >
                    {tenantCodeHeader ? tenantCodeHeader : "Không hợp lệ"}
                  </div>
                )}
              </React.Fragment>
            )}

            <React.Fragment>
              <div
                className="d-flex align-items-center"
                style={{
                  marginRight: "12px",
                  marginLeft: "30px",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                Chi nhánh:
              </div>
              {listBuOfTenant && listBuOfTenant.length > 1 ? (
                <div
                  className="app-search d-lg-block"
                  style={{ minWidth: "200px", marginTop: "10px" }}
                >
                  <Select
                    placeholder="Chi nhánh..."
                    value={selectedBU}
                    onChange={e => {
                      setSelectedBU(e);
                    }}
                    options={listBuOfTenant}
                    classNamePrefix="select2-selection"
                  />
                </div>
              ) : (
                <div
                  className="d-flex align-items-center"
                  style={{
                    color: "white",
                  }}
                >
                  {selectedBU && selectedBU.label}
                </div>
              )}
            </React.Fragment>
            {listBuStore && listBuStore.length > 0 && (
              <React.Fragment>
                <div
                  className="d-flex align-items-center"
                  style={{
                    marginRight: "12px",
                    marginLeft: "30px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Đơn vị:
                </div>
                {listBuStore.length > 1 ? (
                  <div
                    className="app-search d-lg-block"
                    style={{ minWidth: "200px", marginTop: "10px" }}
                  >
                    <Select
                      placeholder="Chọn đơn vị..."
                      value={selectedStore}
                      onChange={e => {
                        setSelectedStore(e);
                      }}
                      options={listBuStore}
                      classNamePrefix="select2-selection"
                    />
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center"
                    style={{
                      color: "white",
                    }}
                  >
                    {selectedStore && selectedStore.label}
                  </div>
                )}
              </React.Fragment>
            )}

            <div className="dropdown-mega d-none d-lg-block ms-2"></div>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.t("Search") + "..."}
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* <LanguageDropdown /> */}

            {/* <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item noti-icon "
                onClick={() => {
                  toggleFullscreen();
                }}
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div> */}

            <NotificationDropdown />

            <ProfileMenu />

            {/* <div className="dropdown d-inline-block">
              <button
                onClick={toggleTopDrawer}
                disabled={open}
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
      <ReactDrawer open={open} position={position} onClose={onDrawerClose}>
        <RightSidebar onClose={onDrawerClose} />
      </ReactDrawer>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
